export const SETTINGS = {
  AUTH: {
    PUBLIC_KEY: process.env.VUE_APP_TOKEN_PUBLIC_KEY,
    TOKEN_NAME: 'apollo-token',
    REFRESH_TOKEN: 'jwt-refresh-token'
  }
}
